import {get, post} from './Tools';

const aplicarCorreccion = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}correccion_acumulados_anuales/aplicar-correccion`, payload);
  return response;
};

const obtenerHistorial = async (empleado_id, anio) => {
  let url = `${process.env.REACT_APP_SERVER}correccion_acumulados_anuales/historial?`;
  if (empleado_id) url += `empleado_id=${empleado_id}&`;
  if (anio) url += `anio=${anio}`;
  const response = await get(url);
  return response;
};

const obtenerHistorialDetalle = async (correccion_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}correccion_acumulados_anuales/historial-detalle/${correccion_id}`);
  return response;
};

const obtenerAcumulados = async (empleado_id, anio) => {
  const response = await get(`${process.env.REACT_APP_SERVER}correccion_acumulados_anuales/acumulados?empleado_id=${empleado_id}&anio=${anio}`);
  return response;
};

export { aplicarCorreccion, obtenerHistorial, obtenerHistorialDetalle, obtenerAcumulados };
